import Backbone from 'backbone';
import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import { getLanguages } from '@bingads-webui-campaign-legacy/adextension-actionlink/model/language-type-text-mapper';
import { getHotelCenterShared } from '@bingads-webui-campaign/hotel-center-shared';
import template from '@bingads-webui-campaign-legacy/adextension-actionlink/template/search-selector-adapter.pug';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
const permissions = config.get('permissions');

const languages = getLanguages();
const maxOptions = 100;
const { DropdownSearchSelector } = getHotelCenterShared();
const BoostOnlySupportedLanguages = [
  'Catalan',
  'Gaelic',
  'Korean',
  'Ukrainian',
];
const BoostSupportedLanguages = [
  'Arabic',
  'Catalan',
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'Finnish',
  'French',
  'Gaelic',
  'German',
  'Greek',
  'Hebrew',
  'Hindi',
  'Hungarian',
  'Indonesian',
  'Italian',
  'Japanese',
  'Korean',
  'Norwegian',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'SimplifiedChinese',
  'Slovak',
  'Spanish',
  'Swedish',
  'Thai',
  'TraditionalChinese',
  'Turkish',
  'Ukrainian',
  'Vietnamese',
  'Malay',
];

if (permissions && permissions.IsBoostCTAPhase2Enabled) {
  BoostOnlySupportedLanguages.push(
    'Afrikaans',
    'Amharic',
    'Armenian',
    'Assamese',
    'Azerbaijani',
    'Basque',
    'Bengali',
    'Cambodian',
    'Galician',
    'Georgian',
    'Gujarati',
    'Kannada',
    'Kazakh',
    'Laotian',
    'Malayalam',
    'Maori',
    'Marathi',
    'Nepali',
    'Oriya',
    'Persian',
    'Punjabi',
    'Quechua',
    'Tamil',
    'Telugu',
    'Urdu',
    'Uzbek',
    'Welsh',
  );
  BoostSupportedLanguages.push(
    'Afrikaans',
    'Albanian',
    'Amharic',
    'Armenian',
    'Assamese',
    'Azerbaijani',
    'Basque',
    'Bengali',
    'Cambodian',
    'Estonian',
    'Galician',
    'Georgian',
    'Gujarati',
    'Kannada',
    'Kazakh',
    'Laotian',
    'Malay',
    'Malayalam',
    'Maori',
    'Marathi',
    'Nepali',
    'Oriya',
    'Persian',
    'Punjabi',
    'Quechua',
    'Tamil',
    'Telugu',
    'Urdu',
    'Uzbek',
    'Welsh',
    'Bulgarian',
    'Bosnian',
    'Croatian',
    'Icelandic',
    'Lithuanian',
    'Latvian',
    'Macedonian',
    'Maltese',
    'Slovenian',
  );
}

function dataSource({
  isMultimediaAd,
  isBoostScenario,
  isDisplayPlusMMA,
  isMMAAutomatedCTAOptInEnabled,
}) {
  const options = _.chain((isMultimediaAd && !isMMAAutomatedCTAOptInEnabled) || isDisplayPlusMMA ? ['None'].concat(languages) : languages)
    .filter((lang) => isBoostScenario || !BoostOnlySupportedLanguages.includes(lang)) // only include when Boost scenario
    .filter((lang) => !isBoostScenario || BoostSupportedLanguages.includes(lang)) // When boost, only include Boost supported ones
    .map((lang) => ({
      id: lang,
      value: i18n.get(`Language_${lang}`) || lang,
    }))
    .value();

  if (((isMultimediaAd && !isMMAAutomatedCTAOptInEnabled) || isDisplayPlusMMA) && options.length > 0 && options[0].id === 'None') {
    options[0] = {
      id: 'None',
      value: i18n.get('Language_Automated'),
    };
  }
  return {
    totalCount: _.size(options),
    options,
  };
}

/* eslint new-cap:0 */
export default class View extends Backbone.View {
  initialize({ observable, viewModel, entity = null, field = null, isMultimediaAd = false, callback = undefined, isBoostScenario, isDisplayPlusMMA = false, isMMAAutomatedCTAOptInEnabled = false, noEntiyCheck = false }) {
    this.observable = observable;
    if (_.isEmpty(this.observable())) {
      if ((isMultimediaAd && !isMMAAutomatedCTAOptInEnabled) || isDisplayPlusMMA) {
        this.observable('None');
      } else if (isBoostScenario) {
        this.observable('None');
      } else {
        this.observable(_.first(languages));
      }
    }
    this.viewModel = viewModel;
    this.isMultimediaAd = isMultimediaAd;
    this.isBoostScenario = isBoostScenario;
    this.isDisplayPlusMMA = isDisplayPlusMMA;
    this.isMMAAutomatedCTAOptInEnabled = isMMAAutomatedCTAOptInEnabled;

    if (this.isMultimediaAd && !noEntiyCheck) {
      if (!(entity instanceof Backbone.Model)) {
        throw new Error('entity should be a backbone model');
      }

      if (_.isEmpty(field)) {
        throw new Error('field is required');
      }

      this.field = field;
      this.entity = entity;
    }
    this.callback = callback;
  }

  setDropdownSearchSelector() {
    if (this.dropdownSearchSelector) {
      this.dropdownSearchSelector.remove();
    }
    const language = this.observable();
    let selectOption = {
      id: language,
      value: i18n.get(`Language_${language === 'None' ? 'Automated' : language}`) || language,
    };

    if (((this.isMultimediaAd && !this.isMMAAutomatedCTAOptInEnabled) || this.isDisplayPlusMMA) && _.isEmpty(this.observable())) {
      selectOption = {
        id: 'None',
        value: i18n.getString('Language_Automated'),
      };
    }

    this.dropdownSearchSelector = new DropdownSearchSelector({
      selectOption,
      dataSource: (arg) => dataSource(_.extend({}, arg, {
        isMultimediaAd: this.isMultimediaAd,
        isBoostScenario: this.isBoostScenario,
        isDisplayPlusMMA: this.isDisplayPlusMMA,
        isMMAAutomatedCTAOptInEnabled: this.isMMAAutomatedCTAOptInEnabled,
      })),
      pageSize: maxOptions,
      i18n,
    }).render();
    if (this.callback && selectOption) {
      this.callback(selectOption);
    }
    this.dropdownSearchSelector.on('option-selected', (selectedOption) => {
      this.observable(selectedOption.id);
      if (this.callback) {
        this.callback(selectedOption);
      }
    });
    this.$('.actionextension-search-dropdown-container').append(this.dropdownSearchSelector.el);
  }

  render() {
    this.$el.html(template());
    this.setDropdownSearchSelector();
    return this;
  }
}
